// Utils
function debounce(callback, wait) {
    let timeoutId = null
    return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
        callback.apply(null, args)
        }, wait)
    }
}
function objectToArray(object) {
    let arr = []
    for (const [key, value] of Object.entries(object)) {
        let obj = {}
        obj[key] = value
        arr.push(obj)
    }
    return arr
}

// Objects
class WindowQuery {
    constructor(queries) {
        this.queries = objectToArray(queries)
        this.build()
    }
    findMatch() {
        // 1. Find the first matching query
        let result = (() => {
            for(var i = 0; i < this.queries.length; i++) {
                for (const [key, value] of Object.entries(this.queries[i])) {
                    if(window.matchMedia(`(max-width: ${value})`).matches) {
                        return Object.keys(this.queries[i - 1])[0]
                    }
                }
            }
        })()


        // 2. If query is out of bounds, set result to largest available query name
        if(result === undefined) {
            result = Object.keys(this.queries[this.queries.length-1])[0]
        }

        // 3. Run the method that matches
        if(this[result] !== undefined) {
            this[result]()
        }

        
    }
    build() {
        // 1. Find initial window size
        window.addEventListener('DOMContentLoaded', () => {
            // 2. Find new match on resize
            window.addEventListener('resize', debounce((e) => {this.findMatch()}, 250))
        })
    }
    init() {this.findMatch();}
}

class Accordions {
    constructor(container, config) {
        this.accordions = this.build(container) 
        this.nested = config.nested || false
        this.open = config.open || false
        this.init()
    }
    build(container) {
        const accordions = container.querySelectorAll(".\\@accordion")
        let arr = []

        accordions.forEach(container => {
            let obj = {
                container: container,
                btn: container.querySelector(".\\@expand"),
                content: container.querySelector(".\\@content"),
                tl: gsap.timeline(),
                active: false,
            }
            arr.push(obj)
        })
        return arr
    }
    init() {
        this.accordions.forEach(accordion => {
            accordion.tl.from(accordion.content, {duration: 0.3, height: 0})

            accordion.open = () => {
                let scrollHeight = accordion.content.scrollHeight
                accordion.tl.to(accordion.content, {duration: 0.5, height: scrollHeight})
                accordion.container.classList.add('active')
                accordion.active = true
            }
            accordion.close = () => {
                accordion.tl.to(accordion.content, {duration: 0.3, height: 0})
                accordion.container.classList.remove('active')
                accordion.active = false
            }
            accordion.btn.addEventListener('click', (e) => {
                e.preventDefault()

                if(this.nested === true && accordion.active !== true) {
                    this.closeAll()
                }   

                accordion.active ? accordion.close() : accordion.open()    
            })
        }) 

        if(this.nested === true && this.open === true) {
            this.accordions[0].open()
        }
    }
    closeAll() {
        this.accordions.forEach(accordion => {
            accordion.close()
        })
    }
}
class Gallery {
    constructor(container, config) {
        this.container = container
        this.config = config || {}
        this.images = this.container.querySelectorAll("img")
        this.onPlay = config.onPlay || undefined
        this.panels = this.buildPanels(config.panels) || undefined
        this.nav = this.buildNav(config.nav) || undefined
        this.prevBtn = this.buildPrevBtn(config.prev) || undefined
        this.nextBtn = this.buildNextBtn(config.next) || undefined
        this.touch = this.buildTouch(config.touch) || undefined
        this.auto = this.autoplay(config.autoplay) || undefined
        this.current = config.start || 0
        this.init()
    }
    buildPanels(sel) {
        const container = this.container.querySelector(sel)

        // 1. Add panels to DOM
        let str = ``
        this.images.forEach(image => {
            str += `<div class="flex-grow"></div>`
        })
        container.innerHTML = str

        // 2. Add events to each panel
        this.panels = container.querySelectorAll('div')
        this.panels.forEach((panel, i) => {
            panel.addEventListener('mouseenter', (e) => {
                this.current = i
                this.play()
            })
        })
    }
    buildPrevBtn(sel) {
        if(sel !== undefined) {
            const btn = this.container.querySelector(sel)
            btn.addEventListener('click', (e) => {
                e.preventDefault()
                this.prev()
            }) 
    
            return btn
        }
    }
    buildNextBtn(sel) {
        if(sel !== undefined) {
            const btn = this.container.querySelector(sel)
            btn.addEventListener('click', (e) => {
                e.preventDefault()
                this.next()
            })
    
            return btn
        }
    }
    buildNav(sel) {        
        if(sel !== undefined) {
            let container = this.container.querySelector(sel)

            // 1. Add bullets to DOM
            let str = ''
            let elHTML = container.querySelector('div').outerHTML
            for(var i = 0; i < this.images.length; i++) {
                str += elHTML
            }
            container.innerHTML = str
    
            // 2. Add events to bullets
            this.bullets = container.querySelectorAll('div')
            this.bullets.forEach((bullet, i) => {
                bullet.addEventListener('click', (e) => {
                    e.preventDefault()
                    this.current = i
                    this.play()
                })
            })
        }  
    }
    buildTouch(settings) {
        if(this.config.touch !== undefined) {
            let container = this.container.querySelector(settings.container)
            const factor = this.container.offsetWidth / (this.images.length - 1)

            // 1. Touchstart
            container.addEventListener('touchstart', (e) => {
                e.preventDefault()
                setTimeout(settings.onStart, settings.startDelay)
            })

            // 2. Touchmove
            container.addEventListener('touchmove', debounce((e) => {
                e.preventDefault()
                let xPos =  Math.round(e.touches[0].pageX / factor)

                this.current = xPos
                this.play()
            }, 0))

            // 3. Touchend
            container.addEventListener('touchend', (e) => {
                e.preventDefault()
                setTimeout(settings.onEnd, settings.endDelay)
            })
        }
    }
    autoplay() {}
    play() {
        if(this.current < 0) {this.current = this.images.length-1} 
        else if(this.current > this.images.length-1) {this.current = 0}

        if(this.onPlay !== undefined) {this.onPlay(this)}
    }
    next() {this.play(this.current++)}
    prev() {this.play(this.current--)}
    init() {this.play(this.current)}
}


// Interfaces
document.addEventListener("DOMContentLoaded", function() {
const inputNum = document.querySelectorAll('.\\@uiNum');

if(inputNum != undefined) {
    inputNum.forEach((container, i) => {
        let input = container.querySelector('input');
        let plusBtn = container.querySelector('[data-btn="plus"]');
        let minusBtn = container.querySelector('[data-btn="minus"]');
        let step = parseInt(input.step);

        plusBtn.addEventListener('click', (e) => {
            e.preventDefault();

            val = parseInt(input.value)
            if(val < parseInt(input.max)) {input.value = val + step}
        })

        minusBtn.addEventListener('click', (e) => {
            e.preventDefault();
    
            val = parseInt(input.value)
            if(val > parseInt(input.min)) {input.value = val - step}
        })
    })
}
});